import { useMemo } from 'react';

export const useRows = (weeklyPayrollReportData) => {
  return useMemo(() => {
    if (!weeklyPayrollReportData?.length) {
      return [];
    }

    const fieldNames = [
      'employeeNumber',
      'rank',
      'fullName',
      'regularHours',
      'sickHours',
      'vacationHours',
      'totalHours',
      'hourlyRate',
      'weeklyPay',
      'additionalHours',
      'rate2',
      'rate23',
      'amount1',
      'rate34_50',
      'amount2',
      'hourlyRate2',
      'overtimeHours1',
      'overtimeRate1',
      'overtimeHours2',
      'overtimeRate2',
      'overtimeHours3',
      'overtimeRate3',
      'hours10',
      'amount3',
      'detail',
      'totalPay',
    ];

    // Transform the data array into row objects
    return weeklyPayrollReportData.map((row, rowIndex) => {
      const rowObject = {
        id: rowIndex,
      };

      // Add each cell value with a field name that matches the column definition
      row.forEach((cellValue, cellIndex) => {
        if (cellIndex < fieldNames.length) {
          rowObject[fieldNames[cellIndex]] = cellValue;
        } else {
          // Fallback for any additional columns not in our mapping
          rowObject[`col${cellIndex}`] = cellValue;
        }
      });

      return rowObject;
    });
  }, [weeklyPayrollReportData]);
};

export default useRows;
